const caseService = process.env.VUE_APP_CASES_WS
const { io } = require('socket.io-client')
class CaseSocket {
  constructor() {
    this.socket = null
    this.isConnected = false
  }

  start(token) {
    try {
      if (this.socket) return
      this.socket = io.connect(caseService, {
        reconnection: true,
        reconnectionDelay: 1000,
        maxReconnectionAttempts: 10,
        transports: ['websocket', 'polling'],
        path: '/socket/cases'
      })
      this.socket.on('connected', () => {
        this.socket.emit('login', { token })
      })
      this.socket.on('login', ({ error }) => {
        if (error) return console.log('%c login failed:', 'color:#ff0000', error)
        console.log('%c login success', 'color:#00ff00')
        this.isConnected = true
        Object.freeze(this)
      })
      this.socket.on('error', ({ error }) => {
        console.log('%c error:', 'color:#ff0000', error)
      })
      return this
    } catch (e) {
      console.error(e)
      this.socket = null
      return this
    }
  }

  emit(event, data) {
    if (this.socket) this.socket.emit(event, data)
    return this
  }

  on(event, callback) {
    if (this.socket) this.socket.on(event, callback)
    return this
  }

  off(event, callback) {
    if (this.socket) this.socket.off(event, callback)
    return this
  }

  once(event, callback) {
    if (this.socket) this.socket.once(event, callback)
    return this
  }

  isAlive() {
    return this.isConnected ? 'CaseSocket is alive' : 'CaseSocket is dead'
  }
}
const caseSocket = new CaseSocket()
module.exports = caseSocket
